import { axiosAPI as axios } from 'utils';

const unwrap = response => {
  const payload = response?.data;
  if (payload && Object.prototype.hasOwnProperty.call(payload, 'data')) return payload.data ?? null;
  return payload ?? response ?? null;
};

export default {
  getPurchaseStatus() {
    return axios.get('/api/mobile-v2/purchases/status').then(unwrap);
  },
  completePurchase(storePurchase) {
    return axios.post('/api/mobile-v2/purchases/complete', { storePurchase }).then(unwrap);
  },
  saveFamilyGoal(goal) {
    return axios.post('/api/mobile-v2/family-goals', goal).then(unwrap);
  },
  deleteFamilyGoal(solutionId) {
    return axios.delete(`/api/mobile-v2/family-goals/${solutionId}`).then(unwrap);
  },
  completeFamilyGoal(goal) {
    return axios.post('/api/mobile-v2/family-goals/complete', goal).then(unwrap);
  },
  getCallHomeStatus() {
    return axios.get('/api/mobile-v2/call-home/status').then(unwrap);
  },
  callHome(familyMemberId, snapshot) {
    return axios.post('/api/mobile-v2/call-home', { familyMemberId, snapshot }).then(unwrap);
  },
};
